{#if notes}
  {#each notes as note, index}
    <NoteListItem 
      note={note}
      on:noteDeleted={(ev) => {deleteNote(ev.detail.noteId)}}
      on:noteUpdated={(ev) => {updateNote(ev.detail.noteId, ev.detail.text)}}/>
  {/each}

  <div class="field has-addons">
    <p class="control is-expanded">
      <textarea
        class="textarea"
        rows={newNoteLines}
        style="line-height:26px;"
        bind:value={newNote}
        on:keypress={(ev) => {
          if (ev.key == 'Enter' && !ev.getModifierState('Shift')) {
            send();
            ev.preventDefault();
          }
        }} />
    </p>
    <p class="control">
      <button class="button is-medium" on:click={() => send()}
        ><span class="icon">
          <i class="mdi mdi-send" />
        </span></button>
    </p>
  </div>
{/if}

<script lang="ts">
  export let id: string;
  export let objectType: string;
  export let count: number = 0;

  import { appState } from '../../../lib/appState';
  import NoteListItem from './NoteListItem.svelte';

  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  let notes: Note_v1_Doc[];

  let newNote = '';
  let loaded = false;

  $: newNoteLines = newNote.split('\n').length;

  get();

  async function get() {
    await window.firebase
      .firestore()
      .collection('notes_v1')
      .where('objectId', '==', id)
      .onSnapshot((docs) => {
        notes = docs.docs
          .map((doc) => {
            return {
              id: doc.id,
              data: doc.data() as Note_v1
            };
          })
          .sort((a, b) => (a.data.timestamp > b.data.timestamp ? 1 : -1));
          
        count = notes.length;

        if(!loaded) {
          dispatch('loaded', { noteCount : count});
          loaded = true;
        }
      });

    
  }

  async function send() {
    const note = {
      text: newNote,
      objectId: id,
      objectType: objectType,
      userId: $appState.auth_user.email,
      timestamp: new Date().toISOString()
    } as Note_v1;

    window.firebase.firestore().collection('notes_v1').add(note);

    newNote = '';
  }

  async function deleteNote(noteId:string) {
    window.firebase.firestore().collection('notes_v1').doc(noteId).delete();
  }

  async function updateNote(noteId:string, text:string) {
    window.firebase
    .firestore()
    .collection('notes_v1')
    .doc(noteId)
    .update({
      text
    });
  }
</script>
